import constantFactory from "@gaoding/constant-factory";

export const {
  MATERIAL_ICON,
  MATERIAL_ICON_LIST,
  MATERIAL_ICON_MAP,
  MATERIAL_ICON_ITEM_MAP,
} = constantFactory("MATERIAL_ICON", [
  {
    key: "img",
    label: "版权图片",
    value: "图片",
    icon: "ic_jpg",
    color: "#466FFF",
  },
  {
    key: "flatTemplate",
    label: "平面模板",
    value: "平面模板",
    icon: "template",
    color: "#FD5656",
  },
  {
    key: "video",
    label: "实拍视频",
    value: "视频",
    icon: "ic_mp4",
    color: "#EC3D65",
  },
  {
    key: "material",
    label: "免扣素材",
    value: "高端免抠",
    icon: "ic_png",
    color: "#FF8A36",
  },
  {
    key: "videoTemplate",
    label: "视频模板",
    value: "视频模板",
    icon: "ic_ae",
    color: "#6D3AFF",
  },
]);
